export default "__VITE_ASSET__BmojFlMw__"